import currentBrand from 'brand-config'

const DEFAULT_ENV = 'dev'

const currentBrandKey = currentBrand.name
const currentEnv = process.env.VUE_APP_CURENV || DEFAULT_ENV
const currentEnvConfig =
  currentBrand.env[currentEnv] || currentBrand.env[DEFAULT_ENV]

const applyBrandTheme = () => {
  if (typeof document === 'undefined') {
    return
  }
  const theme = currentBrand.theme || {}
  const rootStyle = document.documentElement.style
  rootStyle.setProperty('--primary-color', theme.primaryColor)
  rootStyle.setProperty('--primay-warn-color', theme.primaryWarnColor)
  rootStyle.setProperty('--primary-border-radius', theme.primaryBorderRadius)
}

export {
  currentBrandKey,
  currentEnv,
  currentBrand,
  currentEnvConfig,
  applyBrandTheme
}
